import { createContext } from 'react';

export const VendaContext = createContext({
  venda: {
    cliente: null,
    itens: [],
    parcelas: [],
    subTotal: 0,
    idEdit: -1,
    isEditPrice: false,
    tipoVenda: 0,
    descontoOriginal: 0,
    isEmPartes: false,
    idSession: -1,
  },
  dispatch: () => {},
});
